import { Layout } from "antd";
import { SiteHeader } from "../../components";
import "./help.scss";

import { useTranslation } from "react-i18next";
import { useState } from "react";

export function HelpFAQ() {

    const { t } = useTranslation();
    const [copilotOpen, setCopilotOpen] = useState(false);
    return (
        <Layout className="homeLayout">
            <SiteHeader
                copilotOpen={copilotOpen} 
                setCopilotOpen={setCopilotOpen} 
            ></SiteHeader>

            <div className="mainBox" >
                <div style={{ marginTop: 105 }}>
                    <div>
                        <h3 className="helpTitle">{t("常见问题")}</h3>
                    </div>
                    <div style={{ marginTop: 50 }}>
                        <div style={{ marginTop: 25 }}>
                            <h5><strong>1. {t("未瓴移动设备管理平台以及常见名词说明")}</strong></h5>
                        </div>
                        <div style={{ marginTop: 25 }}>
                            <h6><strong>1.1 {t("未瓴移动设备管理平台服务概述")}</strong></h6>
                            <p className="helpContext">{t("提供从设备注册、激活、使用、淘汰各个环节进行完整的移动设备全生命周期管理,高效提升企业IT效率,保障企业信息安全。包括不仅限于设备管理、应用管理、内容管理、资产管理、展台模式、自助服务等。")}
                                <br />
                                <br /> 1、{t("设备管理")}: {t("管理企业的智能手机和平板电脑(Pad)等移动设备,从设备注册,设备信息查询,设备状态查询到设备远程操作,全方位为企业业务和安全保驾护航。")}
                                <br /> 2、{t("应用管理")}: {t("管理整个应用程序生命周期,从应用程序的安装和更新,到管理应用程序的许可证、权限、配置等。企业可以自定义应用间的数据分享权限, 守卫企业数据安全。")}
                                <br /> 3、{t("内容管理")}: {t("定制企业文档和企业通知等分发规则,给不同部门发送不同文档。高度适配Mobile-first 企业,文档集中存放在MDM APP中,授权员工可随时调取,提高工作效率。")}
                                <br /> 4、{t("资产管理")}: {t("快速按照部门、标签等统计设备成本。自购设备折旧和租赁成本一目了然。一键产出资产成本分摊报表,有效帮助部门了解资产使用情况。")}
                                <br /> 5、{t("展台模式")}: {t("在特定用途的设备上设置可使用的应用,一键开启单应用,多应用模式,确保设备只有某些特性是能够访问。设置后的设备,用户交互更加精简,方便设备满足预期用途。")}
                                <br /> 6、{t("自助服务")}: {t("使用自助服务门户功能,员工可以查看和下载部门指定能够访问的应用、文档、通知。帮助IT管理员快速注册设备,提高IT效率,方便管理。")}
                            </p>
                        </div>
                        <div >
                            <h6><strong>1.2 {t("常见名词")}</strong></h6>
                            <p className="helpContext">  
                                    1、APNs: Apple Push Notifications,{t("配置后使得设备能够从苹果服务器接收本平台的操作请求。")}
                                <br /> 2、ABM/ASM: Apple Business/School Manager,{t("配置后能够关联本平台与ABM/ASM账号内的设备、应用数据。")}
                                <br /> 3、VPP: Volume Purchasing Program,{t("配置后能够将ABM/ASM中购买的应用同步到本平台。")}
                                <br />    4、AC2:  {t("Apple Configurator 2 是一款 macOS App,可让您轻松在学校或企业中部署 iPad、iPhone、iPod touch 和 Apple TV 设备。")}{t("主要用来将设备刷监督者模式,或者刷入ABM/ASM账号中。")}
                                <br />    5、{t("监督者模式")}: {t("苹果设备专属,监督可让部门对您拥有的 iOS 设备进行更多的控制,允许设置访问限制,如停用 AirDrop 或 Apple Music,或者将设备置于“单应用模式”中。")}
                                <br />    6、{t("自助服务")}: {t("是一款用于移动设备的App")}
                                <br />    7、Device Owner: {t("安卓设备专属,获得Device Owner权限的设备能够让部门拥有更多的管控权限,如系统功能限制,或者将设备置于“展台模式”中。")}
                                <br />    8、{t("配置文件")}: {t("配置文件能够应用到实际设备的操作,包括不仅限于必要应用、网络配置、密码规则设置、展台模式、锁屏、浏览限制、安全和隐私、功能限制等。")}
                            </p>
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: 25 }}>
                            <h5><strong>2. {t("账号及费用常见问题")}</strong></h5>
                        </div>
                        <div style={{ marginTop: 25 }}>
                            <h6><strong>2.1 {t("账号说明")}</strong></h6>
                            <p className="helpContext">
                                1、{t("主账号")}: {t("注册,付费,管理所有租户的最高等级账号。")}
                                <br /> 2、{t("租户管理员账号")}: {t("管理一个或者多个租户的账号。")}
                                <br /> 3、{t("未瓴SSO账号")}: {t("登录未瓴移动设备管理平台以及其他部分未瓴服务的未瓴专有账号,能够用邮箱注册,同时支持第三方登录,如微软AAD。")}

                            </p>
                        </div>
                        <div >
                            <h6><strong>2.2 {t("新用户使用未瓴移动设备管理平台")}？</strong></h6>
                            <p className="helpContext"> 1、{t("使用未瓴SSO账号登录(如没有先注册)")}
                                <br /> 2、{t("申请使用未瓴数字资产平台")}
                                <br />3、{t("审核后开通使用")}
                            </p>
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: 25 }}>
                            <h5><strong>3. {t("设备管理常见问题")}</strong></h5>
                        </div>
                        <div style={{ marginTop: 25 }}>
                            <h6><strong>3.1 {t("设备使用哪种注册方式")}？</strong></h6>
                            <p className="helpContext">1、{t("苹果设备")}: {t("自有设备弱管控的能够使用简单注册,公司设备或者需要强管控的设备可以使用AC2,ABM/ASM方式,也可以将监督者模式的设备使用简单注册。")}
                                <br /> 2、{t("安卓设备")}: {t("通过下载安卓端App,并绑定账号的方式管控,需要强管控的需要保证机器拥有device owner权限。")}


                            </p>
                        </div>
                        <div >
                            <h6><strong>3.2 {t("设备管理有哪些功能")}？</strong></h6>
                            <p className="helpContext">1、{t("查看设备状态,设备信息,如设备硬件,系统信息,序列号,已安装应用等。")}
                                <br />2、{t("远程操作设备,如锁屏、重启、关机、安装卸载应用、同步状态等。")}

                            </p>
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: 25 }}>
                            <h5><strong>4. {t("应用管理常见问题")}</strong></h5>
                        </div>
                        <div style={{ marginTop: 25 }}>
                            <h6><strong>4.1 {t("有哪些应用类型可以管理")}？</strong></h6>
                            <p className="helpContext">1、{t("苹果应用")}: {t("包括App Store(免费应用、付费应用、自定应用)和企业签名的应用。企业签名的应用(ADEP)无需审核即可发布, 在应用管理—企业应用中上传并管理。")}
                                <br />2、{t("安卓应用")}: {t("需要在本平台上传安卓应用,在应用管理—企业应用中上传并管理所有安卓应用。")}
                            </p>
                        </div>
                        <div >
                            <h6><strong>4.2 {t("设备管理有哪些功能")}</strong></h6>
                            <p className="helpContext">1、{t("同步App Store的应用。")}
                                <br />2、{t("按照部门、标签远程批量安装应用到设备中。")}
                                <br />3、{t("结合自助服务的App,创建企业内部应用商店。")}
                                <br />4、{t("按照应用查看安装该应用的设备")}

                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>

    )

}